// import {gsap} from 'gsap'
// import {ScrollTrigger} from 'gsap/ScrollTrigger'
// import {Flip} from 'gsap/Flip'
// import {ScrollSmoother} from 'gsap/ScrollSmoother';
// import {breakpointUp} from '../utils/breakpoints'
//
// gsap.registerPlugin(ScrollTrigger, Flip, ScrollSmoother);
//
// let flipAnimation;
// // Function to trigger Flip animations when scrolling
// export const triggerFlipOnScroll = (galleryEl, options) => {
//
//   if (flipAnimation) {
//     Flip.killFlipsOf(galleryEl, false);
//     Flip.killFlipsOf(flipAnimation, false);
//     Flip.killFlipsOf('.gallery--stack', false);
//     flipAnimation.kill(true);
//     ScrollTrigger.getById('galleryScroll')?.kill(true);
//
//     gsap.set(galleryEl, {clearProps: "all"}); // Reset element's style
//     gsap.set('.gallery__item, .gallery-wrap .caption', {clearProps: "all"}); // Reset element's style
//
//     flipAnimation = null;
//   }
//
//
//   // Default settings for Flip and ScrollTrigger
//   let settings = {
//     flip: {
//       absoluteOnLeave: false,
//       absolute: false,
//       scale: true,
//       simple: true,
//       //...
//     },
//     scrollTrigger: {
//       start: 'center center',
//       end: '+=300%',
//     },
//     stagger: 0
//   };
//
//   if (!$('.gallery__item').length) {
//     return false
//   }
//
//   // Merge default settings with options provided when calling the function
//   settings = Object.assign({}, settings, options)
//
//
//   // Select elements within the gallery that will be animated
//   const galleryCaption = galleryEl.querySelector('.caption');
//   const galleryItems = galleryEl.querySelectorAll('.gallery__item');
//   const galleryItemsInner = [...galleryItems].map(item => item.children.length > 0 ? [...item.children] : []).flat();
//
//   // Temporarily add the final class to capture the final state
//   galleryEl.classList.add('gallery--switch');
//   const flipstate = Flip.getState([galleryItems, galleryCaption], {props: 'filter'});
//
//
//   // Remove the final class to revert to the initial state
//   galleryEl.classList.remove('gallery--switch');
//
//   // Create the Flip animation timeline
//   flipAnimation = Flip.to(flipstate, {
//     ease: 'none',
//     absoluteOnLeave: settings.flip.absoluteOnLeave,
//     absolute: settings.flip.absolute,
//     scale: settings.flip.scale,
//     simple: settings.flip.simple,
//     scrollTrigger: {
//       id: 'galleryScroll',
//       trigger: galleryEl,
//       start: settings.scrollTrigger.start,
//       end: settings.scrollTrigger.end,
//       pin: galleryEl.parentNode,
//       scrub: true,
//       //markers: true
//       onUpdate: (self) => {
//         const progress = self.progress; // Get the progress of the ScrollTrigger (0 to 1)
//         if (progress >= 0.8) {
//           const opacity = (progress - 0.8) * 5; // Calculate opacity (0 to 1 as progress goes from 0.8 to 1)
//           gsap.to(galleryCaption, { opacity: opacity, overwrite: 'auto' });
//         } else {
//           const opacity = progress * 2; // Calculate opacity (0 to 1 as progress goes from 0 to 0.5)
//           gsap.to(galleryCaption, { opacity: 0, overwrite: 'auto' });
//         }
//       }
//     },
//     stagger: settings.stagger
//
//   });
//
//   // If there are inner elements in the gallery items, animate them too
//   // if (galleryItemsInner.length) {
//   //   flipAnimation.fromTo(galleryItemsInner, {
//   //     scale: 1.1
//   //   }, {
//   //     scale: 1,
//   //     scrollTrigger: {
//   //       trigger: galleryEl,
//   //       start: settings.scrollTrigger.start,
//   //       end: settings.scrollTrigger.end,
//   //       scrub: true,
//   //       //markers: true
//   //     },
//   //   }, 0)
//   // }
// };
//
//
// $(window).on('load', function () {
//   if (breakpointUp('xl')) {
//     triggerFlipOnScroll(document.querySelector('#gallery-2'))
//   }
//   ScrollTrigger.refresh();
// });
//
// let lastWidth = $(window).width();
//
// $(window).on('resize', function () {
//   const currentWidth = $(window).width();
//   if (currentWidth !== lastWidth) {
//     lastWidth = currentWidth;
//     triggerFlipOnScroll(document.querySelector('#gallery-2'))
//   }
// })
